module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_chocolatey_almonds-f20dfb60.png";